// extracted by mini-css-extract-plugin
export default {"wrapper":"WSStepper-module_wrapper-GskF4","plus":"WSStepper-module_plus-imkEa","minus":"WSStepper-module_minus-ZkMxM"};